import api from "config/api";

export type DeliveryChargesResult = {
  charges: number;
  distance: number | null;
};

export const isKmDeliveryChargesEnabled = (settings: any) =>
  Number(settings?.ApplyDeliveryChargesAsKm || 0) === 1;

export const getSelectedDeliveryAddress = (data: any) =>
  String(
    data?.selectedAddress === "office" ? data?.address1 || "" : data?.address || ""
  ).trim();

export const getFixedDeliveryCharge = (companyData: any) =>
  +Number(companyData?.deliveryCharge || 0).toFixed(2);

export const parseDeliveryChargesResponse = (response: any): DeliveryChargesResult => {
  const payload =
    [
      response,
      response?.data,
      response?.Data,
      response?.result,
      response?.Result,
      response?.response,
      response?.Response,
    ].find(
      (item) =>
        item &&
        (item.charges !== undefined ||
          item.Charges !== undefined ||
          item.distance !== undefined ||
          item.Distance !== undefined)
    ) || response;

  const charges = Number(payload?.charges ?? payload?.Charges ?? 0);
  const distance = Number(payload?.distance ?? payload?.Distance);

  return {
    charges: +Number(Number.isFinite(charges) ? charges : 0).toFixed(2),
    distance: Number.isFinite(distance) ? +distance.toFixed(2) : null,
  };
};

export const fetchDeliveryChargesForAddress = async (
  address: string
): Promise<DeliveryChargesResult> => {
  const { data } = await api.get("/api/DeliveryCharge", {
    params: { address },
  });

  return parseDeliveryChargesResponse(data);
};
